export default __webpack_public_path__ + "static/media/technology_object_ghoul.d18db590.gif";